<template>
	<div id="main_div">

		<MainMenu :dentations="dentations" :bones="bones" :nerves="nerves" :airways="airways" :allTeeth="allTeeth"
			:implants="implants" :crowns="crowns" :hasReports="hasReports" :currentStages="currentStages"
			:treatmentStages="treatmentStages" :shortLink="shortLink" :shareLink="shareLink"
			:readonlyLink="readonlyLink" :isStitched="isStitched" :isIntraoral="isIntraoral"
			:isIntraoralView="isIntraoralView" :isEngineerMode="isEngineerMode" :isHighQuality="isHighQuality"
			:hasDicom="hasDicom" :isNoTeeth="isNoTeeth" :isViewMode="isViewMode" :isDicomOpen="isDicomOpen"
			:dicomLowLink="dicomLowLink" :dicomMiddleLink="dicomMiddleLink" :dicomHighLink="dicomHighLink"
			:isMobileDevice="isMobileDevice" :isValidTreatment="isValidTreatment" :isOnlyDicom="isOnlyDicom"
			:isOcclusionAvailable="isOcclusionAvailable" />

		<div id="views_cont" class="flex-container">
			<div id="views3d_wrapper" class="flex-item">
				<div id="views3d_cont">
					<div id="stl_wrapper" class="view-flex-item" v-show="!isDicom3DView || isSplitView">
						<div id="stl_cont">
						</div>

						<div class="cbct-zoom-container" v-show="isStlLoaded">
							<img :src="isWhite ? 'images/plus_blue.png' : 'images/white_plus.png'" class="cbct-zoom-btn"
								v-on:click="changeZoom(1)" title="Increase Zoom" />
							<img :src="isWhite ? 'images/minus_blue.png' : 'images/white_minus.png'"
								class="cbct-zoom-btn" v-on:click="changeZoom(-1)" title="Decrease Zoom" />
							<!-- <img src="images/reset.png" class="dicom-zoom-btn" v-on:click="resetZoom()" title="Reset" /> -->
						</div>

						<div id="isStitchingHint" v-show="isStitching || isAnnotationSaving">
							<span> {{ isStitching ? 'Stitching in progress...' : 'Saving changes...' }} </span>
							<img class="progress-small-img" src="images/dark-blue-spinner.gif" />
						</div>

						<div id="saveListBtn" class="save-list-btn teeth-list-ctrl">
							<img v-show="!isCloudSaving" id="saveListBtn" title="Save" class="save-list-img"
								:src="isWhite ? 'images/save_blue.png' : 'images/save_white.png'"
								v-on:click="saveListClick()" />

							<img v-show="isCloudSaving" id="saveListProgress" title="Saving..." class="save-list-img"
								src="images/dark-blue-spinner.gif" />
						</div>

						<div v-if="!isAnonymized" id="lbPatientName" class="teeth-list-ctrl"
							v-bind:style="{ color: isWhite ? blueColor : whiteColor }"> {{
			patientFirstName }} {{
			patientLastName }}</div>

						<img id="teethListBtn" ref="teethListBtn" data-toggle="collapse" data-target="#teethListPanel"
							aria-expanded="false" title="Settings" class="teeth-list-btn teeth-list-ctrl"
							:src="isWhite ? 'images/menu_blue.png' : 'images/menu_white.png'" />

						<TeethListPanel :viewSourceType="viewSourceType" :isStitching="isStitching"
							:isStitched="isStitched" :isDicomOpen="isDicomOpen" :allItems="allItems"
							:hasClosedBones="hasClosedBones" :hasSolidBones="hasSolidBones" :hasFullBones="hasFullBones"
							:isOnlyTeeth="isOnlyTeeth" :isNoTeeth="isNoTeeth" :isViewMode="isViewMode"
							:savedData="savedData" :teethOpacity="teethOpacity"
							:isOcclusionAvailable="isOcclusionAvailable" :snapToOcclusion="snapToOcclusion"
							:teethNaming="teethNaming" :bonesType="bonesType" :isMaxillaVisible="isMaxillaVisible"
							:isMandibleVisible="isMandibleVisible" />

						<ShowHideControls :isWhite="isWhite" :whiteColor="whiteColor" :blueColor="blueColor" />
						<ColorControls :isWhite="isWhite" :whiteColor="whiteColor" :blueColor="blueColor" />
						<input id="selectColorControl" type="text" class="coloris" value="#ffffff" />

						<OpacityMode />

						<SaveButtons />
						<BottomPanel :fromShareLink="fromShareLink" :isViewMode="isViewMode"
							:allowDownloads="allowDownloads" v-show="isStlLoaded" :isWhite="isWhite"
							:whiteColor="whiteColor" :blueColor="blueColor" :airways="airways"
							:airwayMessage="airwayMessage" />

						<div id="viewModeHint" v-if="isViewMode">VIEW MODE</div>
					</div>
					<div id="dicom_3d_wrapper" class="view-flex-item" v-show="isDicom3DView || isSplitView">
						<div v-if="isOnlyDicom" id="dicomProcessingDiv">Case Processing...</div>
						<button v-if="isOnlyDicom" id="dicom3dLoadBtn" class="save-button"
							v-on:click="loadDicom3DClick()">
							Load CBCT 3D
						</button>
					</div>
					<!-- <img id="segmented_view_btn" class="switch-view-btn" v-show="isDicomLoaded"
						v-on:click="switchSegmentedView"
						:src="isSegmentedView ? 'images/3d_red.png' : 'images/3d_white.png'" title="Segmented View"> -->

					<img v-if="!isOnlyDicom" id="dicom_view_btn" class="switch-view-btn"
						v-show="isDicomLoaded && isDicomOpen && !isSplitView" v-on:click="switchDicom3dView"
						:src="isDicom3DView ? 'images/dicom_red.png' : isWhite ? 'images/dicom_blue.png' : 'images/dicom_white.png'"
						title="Dicom 3D View">

					<img v-if="!isOnlyDicom && !isMobileDevice" id="split_view_btn" class="switch-view-btn"
						v-show="isDicomLoaded && isDicomOpen" v-on:click="switchSplitView"
						:src="isSplitView ? 'images/split_red.png' : isWhite ? 'images/split_blue.png' : 'images/split_white.png'"
						title="Split View">

					<!-- <img v-if="!isOnlyDicom" id="analysisListBtn" data-toggle="collapse"
						v-show="isDicomLoaded && isDicomOpen" data-target="#analysisListPanel" aria-expanded="false"
						title="3D Analysis" class="switch-view-btn"
						:src="isWhite ? 'images/menu_blue.png' : 'images/menu_white.png'" />

					<AnalysisListPanel v-show="isDicomLoaded && isDicomOpen" /> -->

				</div>
			</div>

			<!--<DicomViewer :app="{ divId: 'demo_dicom', orientation: 'axial', toolName: 'dragDrop', color: 'red' }"
				style="width: 49%; height: 100%; display: block;" /> -->
		</div>

		<div id="open_json" class="custom-file" style="display:none">
			<input id="input_json" type="file" class="custom-file-input" onchange="loadJson();" accept="*.json" />
			<label class="custom-file-label" for="input_json">Open JSON configuration</label>
		</div>

		<img id="globalSpinner" class="centered-spinner" src="images/dark-blue-spinner.gif" />

		<div id="loader" v-bind:style="{ color: isWhite && !isIntraoralView ? blueColor : whiteColor }">

			<!-- v-bind:style="{ color: blueColor }" -->
			<!-- v-bind:style="{ color: isWhite && !isIntraoralView ? blueColor : whiteColor }" -->

			<img id="loaderImage"
				:src="isWhite && !isIntraoralView ? 'images/dark-blue-spinner.gif' : 'images/Spinner-2.1s-200px.gif'" />

			<!-- src="images/dark-blue-spinner.gif"  -->
			<!-- :src="isWhite && !isIntraoralView ? 'images/dark-blue-spinner.gif' : 'images/Spinner-2.1s-200px.gif'" -->
			<div id="loaderText">Loading data... Please wait</div>
			<div id="loaderText2"></div>
			<div id="loaderText3"></div>
		</div>

		<div id="annotation-add-menu" class="annotation-menu">
			<button id="annotation-start-nerve-btn" class="annotation-nerve-btn"> Set Start Nerve Point </button>
			<button id="annotation-end-nerve-btn" class="annotation-nerve-btn"> Set End Nerve Point </button>
			<button id="annotation-middle-nerve-btn" class="annotation-nerve-btn"> Add Middle Nerve Point </button>
			<button id="interpolate-nerve-btn" class="annotation-nerve-btn"> Interpolate Nerve </button>
			<button id="annotation-add-btn" class="annotation-add-btn">Add Layer</button>
			<button id="annotation-add-neighbour-btn" class="annotation-add-btn">Add Neighbour Layer</button>
			<button id="annotation-clone-closest-btn" class="annotation-add-btn">Clone Closest Layer</button>
			<button id="annotation-clone-btn" class="annotation-add-btn">Clone Last Edited</button>
		</div>

		<div id="annotation-tooth-menu" class="annotation-menu">
			<button id="tooth-edit-btn">Edit</button>
			<button id="tooth-focus-btn">Focus</button>
			<button id="annotation-assign-btn">Assign Layer</button>
			<button id="annotation-delete-btn">Delete Layer</button>
			<button id="save-nrrd-btn">Save NRRD</button>

			<button id="annotation-interpolate-btn" class="interpolate-menu-btn">Interpolate All Layers</button>
			<button id="start-interpolate-btn" class="interpolate-menu-btn">Start Interpolate</button>
			<button id="end-interpolate-btn" class="interpolate-menu-btn">End Interpolate</button>
			<button id="selection-interpolate-btn" class="interpolate-menu-btn">Interpolate Start-End</button>
		</div>

		<div id="annotation-nerve-point-menu" class="annotation-menu">
			<button id="annotation-nerve-focus-point-btn">Focus To Point</button>
			<button id="annotation-nerve-remove-point-btn">Remove Point</button>
			<!-- <button id="annotation-nerve-order-point-btn">Set Order</button> -->
		</div>

		<div id="annotation-nerve-anchor-menu" class="annotation-menu">
			<button id="annotation-nerve-remove-anchor-btn">Remove Point</button>
		</div>


		<div id="cbct-tooth-menu" class="tooth-menu">
			<button id="cbct-color-btn" class="tooth-menu-btn">Change Color</button>
			<button id="cbct-delete-btn" class="tooth-menu-btn">Delete Tooth</button>
			<button id="cbct-change-btn" class="tooth-menu-btn">Edit Number</button>
			<button id="cbct-focus-btn" class="tooth-menu-btn">Focus Tooth</button>
			<button id="cbct-focus-dicom-btn" class="tooth-menu-btn">Focus Dicom</button>
			<button id="cbct-hide-btn" class="tooth-menu-btn">Hide Tooth</button>
			<button id="cbct-reset-initial-btn" class="tooth-menu-btn">Reset to initial</button>
			<button id="cbct-reset-current-btn" class="tooth-menu-btn">Reset to current</button>
		</div>

		<div id="intraoral-tooth-menu" class="tooth-menu">
			<button id="intraoral-add-btn" class="tooth-menu-btn">Add Tooth</button>
			<button id="intraoral-add-border-btn" class="tooth-menu-btn">Add Border</button>
			<button id="intraoral-delete-border-btn" class="tooth-menu-btn">Remove Border</button>
			<button id="intraoral-add-measure-btn" class="tooth-menu-btn">Add Measure Line</button>
			<button id="intraoral-focus-btn" class="tooth-menu-btn">Focus on Tooth</button>
			<button id="intraoral-delete-btn" class="tooth-menu-btn">Delete Tooth</button>
			<button id="intraoral-change-btn" class="tooth-menu-btn">Edit Number</button>
			<button id="intraoral-center-btn" class="tooth-menu-btn">Center View</button>
			<button id="intraoral-flip-btn" class="tooth-menu-btn">Flip View</button>
		</div>

		<div id="iopano-menu" class="tooth-menu">
			<button id="iopano-change-btn" class="tooth-menu-btn">Edit Number</button>
			<button id="iopano-delete-btn" class="tooth-menu-btn">Delete Tooth</button>
		</div>

		<div id="ioarch-menu" class="tooth-menu">
			<button id="ioarch-add-btn" class="borderless-btn">Add New Point</button>
			<button id="ioarch-measure-btn" class="borderless-btn">Measure To</button>
			<button id="ioarch-remove-btn" class="tooth-menu-btn">Remove Point</button>
		</div>

		<div id="iomeasure-menu" class="tooth-menu">
			<button id="iomeasure-start-sum-btn" class="tooth-menu-btn">Set Start Sum</button>
			<button id="iomeasure-end-sum-btn" class="tooth-menu-btn">Set End Sum</button>
		</div>

		<OrthoPlanMode v-if="isStlLoaded" :isIntraoral="isIntraoral" :currentStages="currentStages"
			:treatmentStages="treatmentStages" />

		<img v-if="doctorLogo && !isMobileDevice" id="logoImg" :src="doctorLogo" />

		<img v-if="!isMobileDevice" id="trademarkImg"
			:src="isWhite && !isIntraoralView ? 'images/Logo_ORCA_Blue.png' : 'images/Logo_ORCA_White.png'" />
		<!-- <img id="infoImgBtm" src="images/info_icon_white.png" title="Help" v-on:click="showHelp()" /> -->
		<div id="copyrightText" v-bind:style="{ color: isWhite && !isIntraoralView ? blueColor : whiteColor }">Copyright
			&copy; {{ currentYear }} ORCA
			Dental AI LTD, All rights reserved</div>

		<!-- Modal -->
		<ImplantStep1 :lengths="lengths" :diameters="diameters" @set-implant-name="setImplantName" />
		<ImplantStep2 :lengths="lengths" :diameters="diameters" :toothModels="toothModels" :isResize="isResize"
			@set-implant-size="setImplantSize" @add-implant="addImplant" />
		<ImplantStep3 @add-implant="addImplant" @add-crown="addCrown" :isCrownPlacement="isCrownPlacement" />
		<AddCrownMap @set-crown-number="setCrownNumber" @add-crown="addCrown" />
		<Loader :patientFirstName="patientFirstName" :patientLastName="patientLastName" />
		<MarketingPrompt :startmarketingprompt="startmarketingprompt" :opennewtabprompt="opennewtabprompt" />
		<ShareParamsDialog :shortLink="shortLink" />
		<OrthoPlayStages :orthoStages="orthoStages" :currentStages="currentStages" :isOrthoPlaying="isOrthoPlaying" />
		<OrthoTreatmentStages :treatmentStages="treatmentStages" :isTreatmentPlaying="isTreatmentPlaying" />
		<ClipDialog />
		<ReportsDialog />
		<ExportDialog :exportUrlType="exportUrlType" />
		<MultiselectDialog />

	</div>
</template>

<script>

//#region Imports

import swal from "sweetalert";

import { loadStlModels, checkHasDicom, loadDicomApp, showLoadError, checkHasFullBones } from "./components/appStart/loader";
import { createPca } from "./components/geometry/NumericHelper";

import { startIsStitchingWatch, checkIsStitched, switchStitching } from "./components/appStart/stitching";
import MainMenu from "./components/controls/MainMenu.vue";

import TeethListPanel from "./components/controls/TeethListPanel.vue";
import AnalysisListPanel from "./components/dicom/analysis/AnalysisListPanel.vue";

import { ISO, UNS, ALPHANUM, teethNamings } from "./components/tooth/teethNaming.js";
import {
	focusItem, unfocusItem, editItemSettings,
	deleteItem, fetchMandibleTransform,
	switchBonesType
} from './components/controls/TeethListManager';
import {
	focusDicomItem,
} from "@/components/tooth/focus/ToothFocusMode";

import ImplantStep1 from "./components/implants/ImplantStep1.vue";
import ImplantStep2 from "./components/implants/ImplantStep2.vue";
import { initStep2 } from "./components/implants/ImplantStep2.vue";
import ImplantStep3 from "./components/implants/ImplantStep3.vue";

import { generateReport } from "@/components/reports/GenerateReport.js";
import ShareParamsDialog from "./components/share/ShareParamsDialog.vue";
import ClipDialog from "./components/reports/ClipDialog.vue";
import { applyClipData } from "./components/reports/ClipDialog.vue";
import ReportsDialog from "./components/reports/ReportsDialog.vue";
import ExportDialog from "./components/reports/ExportDialog.vue";

import AddCrownMap from "./components/crowns/AddCrownMap.vue";
import { addCrownStl } from "./components/crowns/addCrown.js";
import { addImplantStl } from "./components/implants/addImplant.js";

import MultiselectDialog from "./components/controls/MultiselectDialog.vue";

import { updateRaycaster, intersectTooth, setHighlightedToothColor } from "@/components/intersection";

import {
	b64_to_utf8,
	utf8_to_b64,
	saveViewerData,
	sendReport,
	sendShareReport,
	loadViewerDataFromApi,
	updateZipsForSourceType
} from "./components/saveLoadData";
import {
	sendGetExportDataRequest,
} from "@/api/reportApi";
import {
	getTimeStamps,
} from "@/api/toothApi";
import {
	sendSetGuidsRequest,
} from "@/api/inputJsonApi";

import { getDoctorSettings, } from "@/api/cloudApi";
import { initializeHelpDialog, showHelpDialog } from "./components/help/HelpManager.js";
import { adjustModel, updateToothDentition } from "./components/appStart/adjustModel";
import { airwaySetColor } from "./components/airway/AirwayColor";

import { loadDicom3D } from "./components/vtk/Dicom3dManager";
import { loadDicomUrls } from "./components/dicom/DicomManager.js";
import { loadGingivaCrossData } from "./components/geometry/gingivaHelper";

import Loader from "./components/controls/Loader.vue";
import MarketingPrompt from "./components/controls/MarketingPrompt.vue";
import BottomPanel from "./components/controls/BottomPanel.vue";
import OpacityMode from "./components/opacity/OpacityMode.js";
import ShowHideControls from "./components/showHide/ShowHideControls.vue";
import ColorControls from "./components/color/ColorControls.vue";
import SaveButtons from "./components/controls/SaveButtons.vue";
import OrthoPlanMode from "./components/ortho/OrthoPlanMode.js";

import {
	OrthoPlanMode as opmode, downloadOrhoStages,
	resetToInitial,
	resetToCurrent,
	loadTreatmentMatrixs
} from "./components/ortho/OrthoPlanMode.js";

import {
	fetchTreatmentStages, restoreDefaultGeometries
} from "./components/ortho/treatment/OrthoTreatment.js";

import OrthoPlayStages from "./components/ortho/OrthoPlayStages.vue";
import OrthoTreatmentStages from "./components/ortho/treatment/OrthoTreatmentStages.vue";
import DicomViewer from "./components/dicom/DicomViewer.vue";
import { highlightOutlines } from "./components/dicom/slice.js";

import { showIoViewer } from "./components/intraoral/IntraoralManager";
import { leaveHideMode, visibilityChangedHandler } from "./components/showHide/showHideMode.js";

import {
	ioViewer,
	ioPlane,
	allModels,
} from "./components/intraoral/IntraoralManager";
import { globalPlanes, empty } from "@/components/reports/ClipDialog.vue";
import {
	sendGetCutReportsRequest,
} from "@/api/reportApi";
//#endregion

export default {
	name: "app",
	data() {
		return {
			baseObj: null,
			stlBaseUrl: null,
			stlCopyUrl: null,
			clearCache: false,
			isHighQuality: true,
			isWhite: true,
			whiteColor: "#ffffff",
			blueColor: "#007bff",
			isAnnotationMode: false,
			isEngineerMode: false,
			hasDicom: false,
			isOnlyDicom: false,
			isStitched: false,
			isOcclusionAvailable: false,
			snapToOcclusion: false,
			isStitching: false,
			viewSourceType: "cbct",
			exportUrlType: "nonStitchedUrl",
			isCloudSaving: false,
			isAnnotationSaving: false,
			isOrthoPlaying: false,
			isIntraoral: false,
			isIntraoralView: false,
			isCbctParam: false,
			isStlLoaded: false,
			isDicomLoaded: false,
			isSegmentedView: true,
			isSplitView: false,
			isDicom3DView: false,
			isDicomOpen: false,
			isOnlyTeeth: false,
			isNoTeeth: false,
			isStaging: false,
			hasClosedBones: false,
			hasSolidBones: false,
			hasFullBones: false,
			showTeethRoots: false,
			bonesType: "default",
			isMobileDevice: false,
			defaultFont: null,
			dicomLowLink: false,
			dicomMiddleLink: false,
			dicomHighLink: false,
			dicomData: {},

			isGlb: false,
			activeMode: null,
			teethNaming: ISO,
			doctorLogo: null,
			cache: null,
			jsonLocation: null,
			dicomZipFromJson: null,
			isShareEnabled: true,
			fromShareLink: false,
			allowDownloads: true,
			isExpired: false,
			expiration: 0,
			shareLink: window.location.href,
			shortLink: null,
			readonlyLink: `${window.location.href}?save=false`,
			apiPath: window.location.origin,
			prefix: "DEV",
			viewerServerUrl: window.location.origin,
			crownsPath: `${window.location.href.split(/[?#]/)[0]}/stl/crowns`,
			patientId: 0,
			patientFirstName: "Unknown Client",
			patientLastName: "",
			isAnonymized: false,
			doctorName: "",
			generateReportName: null,
			showmarketingprompt: false,
			startmarketingprompt: false,
			opennewtabprompt: "http://cephx.com",
			dentations: [],
			bones: [],
			nerves: [],
			gingivae: [],
			airways: [],
			airwayMessage: null, // "Generating airway video...", // null, //
			backgroundMessage: null,
			implants: [],
			crowns: [],
			hasReports: false,
			savedReports: [],
			orthoStages: [],
			treatmentStages: [],
			isValidTreatment: false,
			isTreatmentPlayMode: false,
			isTreatmentPlaying: false,
			currentTreatmentStage: null,
			originalTreatmentStage: null,
			currentStageId: -1,
			implantsColor: "#FFC0CB",
			crownsColor: "#FFC0CB",
			bonesColor: "#9A9899",
			bonesOpacity: 0.45,
			nervesColor: "#FF0000",
			nervesOpacity: 1,
			gingivaeColor: "#FFB6C1",
			gingivaeOpacity: 0.85,
			airwaysColor: "#FFFFFF", //"#BA68C8",
			airwaysOpacity: 1,
			teethColor: "#FFFFFF", //"#D0CECF",
			teethOpacity: 1,
			backgroundColor: "#EEF3FF",
			isMaxillaVisible: true,
			isMandibleVisible: true,
			isRandomTeethColor: false,
			zipFile: null,
			zipSegmentation: null,
			isHideMode: false,
			isColorMode: false,
			isOpacityMode: false,
			isAutoRotated: false,
			isCrownPlacement: false,
			lengths: [],
			diameters: [],
			toothModels: [],
			newImplantName: null,
			newImplantLength: 0,
			newImplantDiameter: 0,
			newImplantCrownId: null,
			crownImplantId: null,
			crownNumber: null,
			midlineData: [],
			isResize: false,
			isOcclusal: false,
			isViewMode: false,
			isReset: false,
			isAnonymized: false,
			is3DAllowed: true,
			isCompany: true,
			loaderClosed: false,
			simplifyPercent: 25,
			doctorSettings: null,
			savedData: {
				isLoaded: false,
				isRandomTeethColor: false,
				cameraPosition: null,
				cameraTarget: null,
				clipData: null,
				bonesColor: null,
				bonesOpacity: null,
				teethColor: null,
				teethOpacity: null,
				isMaxillaVisible: true,
				isMandibleVisible: true,
				bones: [],
				dentations: [],
				implants: [],
				crowns: [],
				gingivae: [],
				airways: [],
				nerves: []
			},
			baseData: {
				isLoaded: false,
				cameraPosition: null,
				cameraTarget: null,
				bonesColor: null,
				bonesOpacity: null,
				teethColor: null,
				teethOpacity: null,
				isMaxillaVisible: true,
				isMandibleVisible: true,
				bones: [],
				dentations: [],
				implants: [],
				crowns: [],
				gingivae: [],
				airways: [],
				nerves: []
			},
			versions: null,
			appVersion: null,
			currentYear: new Date().getFullYear()
		};
	},
	components: {
		MainMenu,
		TeethListPanel,
		AnalysisListPanel,
		ImplantStep1,
		ImplantStep2,
		ImplantStep3,
		AddCrownMap,
		Loader,
		MarketingPrompt,
		BottomPanel,
		OpacityMode,
		ShowHideControls,
		ColorControls,
		OrthoPlanMode,
		OrthoPlayStages,
		OrthoTreatmentStages,
		ShareParamsDialog,
		ClipDialog,
		ReportsDialog,
		ExportDialog,
		MultiselectDialog,
		SaveButtons,
		DicomViewer
	},
	methods: {
		initApp: async function (obj) {
			let isMobileOrTablet = mobileAndTabletCheck();
			vueApp.isMobileDevice = isMobileOrTablet;

			$("#orthoMenu").css({ display: "none" });
			vueApp.baseObj = obj;

			let versionKey = `orcaViewerVersion`;
			let versionValue = localStorage.getItem(versionKey);
			if (!versionValue || versionValue != cephxVersion) {
				this.clearCache = true;
				localStorage.setItem(versionKey, cephxVersion);
			}
			// vueApp.appVersion = "v1.6.0.659";
			// cephxVersion = "qa-v1.6.0-develop.659, 2026-08-05T15:13:20+03:00";
			if (cephxVersion != versionTemplate) {
				let tempArr = cephxVersion.split(',');
				vueApp.appVersion = tempArr[0].replace("qa-", "").replace("prod-", "").replace("-develop", "");
			}

			if (obj.defaultSettings) {
				this.bonesColor = obj.defaultSettings.bonesColor;
				// this.bonesOpacity = obj.defaultSettings.bonesOpacity;
				this.nervesColor = obj.defaultSettings.nervesColor;
				this.nervesOpacity = obj.defaultSettings.nervesOpacity;
				// this.teethColor = obj.defaultSettings.teethColor;
				this.teethOpacity = obj.defaultSettings.teethOpacity;
				if (obj.defaultSettings.implantsColor)
					this.implantsColor = obj.defaultSettings.implantsColor;
			}

			if (obj.data) {
				if (obj.data.patientId) this.patientId = obj.data.patientId;
				if (obj.data.patientFirstName)
					this.patientFirstName = this.originalFirstName = obj.data.patientFirstName;
				if (obj.data.patientLastName)
					this.patientLastName = this.originalLastName = obj.data.patientLastName;

				this.doctorId = obj.data.doctorId;
				this.doctorFirstName = obj.data.doctorFirstName;
				this.doctorLastName = obj.data.doctorLastName;
				if (obj.data.doctorFirstName || obj.data.doctorLastName) {
					this.doctorName = `${obj.data.doctorFirstName} ${obj.data.doctorLastName}`;
					this.doctorName = this.doctorName.trim();
				}
				this.logo = obj.data.logo;
				this.age = obj.data.age;
				this.cephDate = obj.data.cephDate;
				this.analysisDate = obj.data.analysisDate;

				if (vueApp.isAnonymized) {
					let tempId = vueApp.patientId % 10000;
					vueApp.patientFirstName = `xxx${tempId}`; // vueApp.patientId;
					vueApp.patientLastName = "";
				} else {
					console.log(new Date(), `initApp doctor: ${this.doctorId} ${this.doctorName} ${this.logo} ${this.age} ${this.cephDate}`);
				}

				let hideLoaderPopup = document.cookie
					.split("; ")
					.find(row => row.startsWith("hideLoaderPopup"));
				// console.log("hideLoaderPopup", hideLoaderPopup);
				if (!hideLoaderPopup) {
					document.cookie = "hideLoaderPopup=true; expires=Fri, 31 Dec 9999 23:59:59 GMT";
					$("#loaderDialog").modal({
						backdrop: "static",
						keyboard: false
					});
				}

				vueApp.versions = obj.data.versions;
				console.log("vueApp.versions", obj.data.versions);

				initializeHelpDialog();

				if (obj.data.zipFile) {
					this.zipFile = obj.data.zipFile;
				}
				if (isMobileOrTablet) {
					this.zipFile = obj.data.mobileZip;
					this.intraoralZipUrl = obj.data.mobileSegmentationStandaloneZip;
				}
				else {
					this.zipFile = obj.data.desktopZip;
					this.intraoralZipUrl = obj.data.desktopSegmentationStandaloneZip;
				}

				this.intraoralPanoramicZipUrl = obj.data.desktopRootsFromPanoramicImageZip;

				if (obj.data.dicomZip) {
					this.dicomZipFromJson = obj.data.dicomZip;
				}

				let zipNearJson = isMobileOrTablet ? `${vueApp.stlBaseUrl}/mobile.zip` : `${vueApp.stlBaseUrl}/desktop.zip`;
				if (this.zipFile && zipNearJson != this.zipFile) {
					let response = await fetch(zipNearJson, { method: "HEAD" });
					if (response.status === 200) {
						this.zipFile = zipNearJson;
						console.log("zipNearJson", zipNearJson);
					}
				}

				if (this.intraoralPanoramicZipUrl) {
					let intraoralNearJson = `${vueApp.stlBaseUrl}/roots-from-panoramic-image.zip`;
					if (intraoralNearJson != this.intraoralPanoramicZipUrl) {
						let response = await fetch(intraoralNearJson, { method: "HEAD" });
						if (response.status === 200) {
							this.intraoralPanoramicZipUrl = intraoralNearJson;
						}
					}
				}

				if (this.intraoralZipUrl) {
					let intraoralNearJson = `${vueApp.stlBaseUrl}/segmentation-standalone-desktop.zip`;
					if (intraoralNearJson != this.intraoralZipUrl) {
						let response = await fetch(intraoralNearJson, { method: "HEAD" });
						if (response.status === 200) {
							this.intraoralZipUrl = intraoralNearJson;
						}
					}
				}
				// console.log("before setS3BaseUrls", new Date());

				await setS3BaseUrls();
				this.isStaging = vueApp.jsonLocation.includes("dfnmtd2iqaeom");
				console.log("isStaging", this.isStaging);

				if (
					window.location.href.includes("192.168.0.") ||
					window.location.href.includes("172.30.5.") ||
					window.location.href.includes("localhost")
				) {
					this.viewerServerUrl = "https://localhost:7060";
				}

				var prod_url = ".cephx.com";
				var qa_url = "qa.ceph-x.com";
				if (obj.data.apiPath) {
					this.apiPath = trim(obj.data.apiPath, "/");
				} else if (this.apiPath.includes(prod_url)) {
					this.prefix = "PROD";
					this.apiPath = "https://cloud.cephx.com";
				} else if (this.apiPath.includes(qa_url)) {
					this.prefix = "QA";
					this.apiPath = "https://qa.ceph-x.com";
				} else if (
					this.apiPath.includes("localhost") ||
					this.apiPath.includes("192.168.0.") ||
					this.apiPath.includes("172.30.5.") ||
					this.apiPath.includes("ec2-35-155-116-156.")
				) {
					this.apiPath = "https://qa.ceph-x.com";
					this.prefix = "DEV";
				}

				console.log(`apiPath: ${this.apiPath}`);

				this.isIntraoral = !!this.intraoralZipUrl;
				if (!this.zipFile) {
					if (this.isIntraoral) {
						vueApp.exportUrlType = "iosUrl";
						showIoViewer();
					}
					else {
						await checkHasDicom();
						if (this.hasDicom) {
							this.isOnlyDicom = true;
							loadDicomApp();
						}
						else {
							showLoadError();
						}
					}
					return;
				}
				let doctorSettings = await getDoctorSettings(this.doctorId, this.patientId);

				console.log("doctorSettings", doctorSettings);
				this.doctorSettings = doctorSettings;
				if (doctorSettings) {
					if (doctorSettings.bonesColor) this.bonesColor = doctorSettings.bonesColor;
					if (doctorSettings.bonesOpacity) this.bonesOpacity = doctorSettings.bonesOpacity;
					if (doctorSettings.nervesColor) this.nervesColor = doctorSettings.nervesColor;
					if (doctorSettings.nervesOpacity) this.nervesOpacity = doctorSettings.nervesOpacity;
					if (doctorSettings.teethColor) this.teethColor = doctorSettings.teethColor;
					if (doctorSettings.teethOpacity) this.teethOpacity = doctorSettings.teethOpacity;

					if (doctorSettings.backgroundColor) {
						this.backgroundColor = doctorSettings.backgroundColor;
					}

					if (doctorSettings.teethNumberingSystem) this.teethNaming = teethNamings[doctorSettings.teethNumberingSystem];
					if (doctorSettings.showLogo && doctorSettings.logoPath) {
						this.doctorLogo = doctorSettings.logoPath;
						console.log("doctorLogo", this.doctorLogo);
					}


					// if (doctorSettings.implantsColor) this.implantsColor = doctorSettings.implantsColor;
				}
				// this.backgroundColor = '#94e59a';

				var sl = window.location.href;
				if (obj.data.shareLink) {
					sl = obj.data.shareLink;
				}
				addthis_share.url = this.shareLink = sl;

				this.readonlyLink = sl.endsWith(".json")
					? `${sl}&save=false`
					: `${sl}?save=false`;

				if (window.location.href === this.readonlyLink) {
					this.isViewMode = true;
				}

				// if (!this.shortLink) {
				// 	this.shortLink = window.location.href;
				// 	shortLink();
				// }

				if (this.fromShareLink) {
					let rmessage = `PatientId: ${this.patientId},  was accessed by ${this.recepientEmail}, ${this.recepientName}`;
					sendShareReport(rmessage);
				}




				if (vueApp.isStitched) {
					// updateZipsForSourceType("cbct");
					startIsStitchingWatch();
				}

				adjustModel(obj);
				this.cacheStamp = obj.data.cacheStamp;
				if (this.cacheStamp) {
					console.log(`cacheStamp: ${this.cacheStamp}`);
					let cacheStampName = `cacheStamp_${vueApp.jsonLocation}`;
					let localStamp = +localStorage.getItem(cacheStampName);

					console.log(`cacheStamp: ${this.cacheStamp}, localStamp: ${localStamp}`);
					if (!localStamp || localStamp != this.cacheStamp) {
						this.clearCache = true;
						localStorage.setItem(cacheStampName, this.cacheStamp);
					}
				}

				let desktopZipTimeStamp = 0;// timeStampsData.timeStamps
				let timeStampsData = await getTimeStamps(vueApp.patientId);
				if (timeStampsData && timeStampsData.timeStamps) {
					let timeStampTag = `STL/${vueApp.s3dicom}/desktop.zip`;
					console.log("timeStampTag", timeStampTag);
					for (var prop in timeStampsData.timeStamps) {
						if (prop.endsWith(timeStampTag)) {
							desktopZipTimeStamp = +timeStampsData.timeStamps[prop];
							break;
						}
					}
				}
				console.log("web desktopZipTimeStamp", desktopZipTimeStamp, timeStampsData);
				let desktopStampName = `desktopZipTimeStamp_${vueApp.patientId}`;
				let localDesktopStamp = +localStorage.getItem(desktopStampName);
				console.log("localDesktopStamp", localDesktopStamp);
				if (localDesktopStamp !== desktopZipTimeStamp) {
					this.clearCache = true;
					this.desktopStampName = desktopStampName;
					this.desktopZipTimeStamp = desktopZipTimeStamp;
					// localStorage.setItem(desktopStampName, desktopZipTimeStamp);
				}
				console.log(`clearCache: ${this.clearCache}`);

				this.isGlb = obj.data.isGlb;

				if (obj.data.crownsPath) {
					this.crownsPath = trim(obj.data.crownsPath, "/");
				} else {
					var href = window.location.href;
					href = href.split(/[?#]/)[0];
					if (href.includes(".html"))
						href = href.substring(0, href.lastIndexOf("/"));
					href = trim(href, "/");
					this.crownsPath = `${href}/stl/crowns`;
				}

				// sendGetExportDataRequest((responseData) => {
				// 	vueApp.exportData = responseData;
				// });

				if (obj.data.dentations) {
					obj.data.dentations.forEach(item => {
						item.isVisible = true;
					});
					var groups = obj.data.dentations.reduce((acc, dent) => {
						if (dent.groups)
							dent.groups.forEach(item => {
								item.dentition = dent.name;
							});
						return dent.groups ? acc.concat(dent.groups) : acc;
					}, []);
					var teeth = groups.reduce((acc, group) => {
						if (group.teeth)
							group.teeth.forEach(item => {
								updateToothDentition(item);
							});
						return group.teeth ? acc.concat(group.teeth) : acc;
					}, []);
					teeth.forEach(item => {
						if (!item.number) {
							const parsed = parseInt(item.name, 10);
							if (parsed) {
								item.number = parsed;
							}
						}
						if (!item.savedNumber) {
							item.savedNumber = item.number;
						}
						item.isTooth = true;
						item.isVisible = true;
						if (!item.color) {
							item.color = this.teethColor;
						}
						if (!item.opacity) {
							item.opacity = this.teethOpacity;
						}
						if (!item.addedTag && item.filename.includes("added")) {
							let add_arr = item.filename.split("-");
							item.addedTag = add_arr[1].replace(".stl", "");
							item.fromAnnotation = true;
							// console.log(item.filename, add_arr, item.addedTag, item.fromAnnotation);
						}
					});

					this.dentations = obj.data.dentations;
				}

				let maxillaDentation = this.dentations.find(d => d.name === "Maxilla");
				if (!maxillaDentation) {
					maxillaDentation = {
						name: "Maxilla", groups: []
					};
					this.dentations.push(maxillaDentation);
				}
				let maxillaGroup1 = maxillaDentation.groups.find(g => g.name === "11-19");
				if (!maxillaGroup1) {
					maxillaGroup1 = { name: "11-19", teeth: [] };
					maxillaDentation.groups.push(maxillaGroup1);
				}
				let maxillaGroup2 = maxillaDentation.groups.find(g => g.name === "21-29");
				if (!maxillaGroup2) {
					maxillaGroup2 = { name: "21-29", teeth: [] };
					maxillaDentation.groups.push(maxillaGroup2);
				}

				let mandibleDentation = this.dentations.find(d => d.name === "Mandible");
				if (!mandibleDentation) {
					mandibleDentation = {
						name: "Mandible", groups: []
					};
					this.dentations.push(mandibleDentation);
				}
				let mandibleGroup1 = mandibleDentation.groups.find(g => g.name === "31-39");
				if (!mandibleGroup1) {
					mandibleGroup1 = { name: "31-39", teeth: [] };
					mandibleDentation.groups.push(mandibleGroup1);
				}
				let mandibleGroup2 = mandibleDentation.groups.find(g => g.name === "41-49");
				if (!mandibleGroup2) {
					mandibleGroup2 = { name: "41-49", teeth: [] };
					mandibleDentation.groups.push(mandibleGroup2);
				}

				if (obj.data.bones) {
					obj.data.bones.forEach(item => {
						item.isVisible = true;
						item.isBone = true;
						item.isMaxilla = item.isUpper = item.filename.includes("maxilla");
						if (!item.color) {
							item.color = this.bonesColor;
						}
						if (!item.opacity) {
							item.opacity = this.bonesOpacity;
						}
					});
					this.bones = obj.data.bones;
				}

				if (obj.data.nerves) {
					obj.data.nerves.forEach(item => {
						item.name = item.name.replace("Merged", "Nerve");
						item.isVisible = true;
						item.isNerve = true;
						if (!item.color) {
							item.color = this.nervesColor;
						}
						if (!item.opacity) {
							item.opacity = this.nervesOpacity;
						}
					});
					this.nerves = obj.data.nerves;
				}

				if (obj.data.gingivae) {
					obj.data.gingivae.forEach(item => {
						item.isVisible = true;
						item.isUpper = item.filename.toLowerCase().includes("upper");
						if (!item.color) {
							item.color = this.gingivaeColor;
						}
						if (!item.opacity) {
							item.opacity = this.gingivaeOpacity;
						}
					});
					this.gingivae = obj.data.gingivae;
				}
				if (obj.data.airways) {
					obj.data.airways.forEach(item => {
						item.isVisible = true;
						item.stlCentered = airwaySetColor;
						item.isFromData = true;
						if (!item.color) {
							item.color = this.airwaysColor;
						}
						if (!item.opacity) {
							item.opacity = this.airwaysOpacity;
						}
					});
					this.airways = obj.data.airways;
				}

				var tempLengths = obj.data.lengths
					? obj.data.lengths
					: [6, 8, 10, 11.5, 13, 15];
				if (tempLengths) {
					tempLengths.forEach((item, index) => {
						var length = { value: item, selected: item == 10 }; //index == Math.floor(tempLengths.length / 2) };
						this.lengths.push(length);
					});
				}

				var tempDiameters = obj.data.diameters
					? obj.data.diameters
					: [3.25, 3.75, 4, 4.2, 5, 6];
				if (tempDiameters) {
					tempDiameters.forEach((item, index) => {
						var diameter = { value: item, selected: item == 4 }; //index == obj.data.diameters ? Math.floor(tempDiameters.length / 2) : 2 };
						this.diameters.push(diameter);
					});
				}

				if (obj.data.is3DAllowed !== undefined) {
					this.is3DAllowed = obj.data.is3DAllowed;
				}

				let algo3dToothInfoUrl = obj.data.midlineJson;
				this.getMidlineData(algo3dToothInfoUrl);
			}

			let i = 1;
			vueApp.allItems.forEach((item) => {
				item.id = i++;
				if (!item.isVisible) Vue.set(item, "isVisible", true);
			});

			// await fetchMandibleTransform();

			let stageModels = [];
			if (obj.stages) {
				stageModels = await fetchTreatmentStages(obj.stages);
			}
			if (vueApp.savedData.isLoaded || (vueApp.isReset && vueApp.isViewMode)) {
				loadStlModels(stageModels);
			} else {
				loadViewerDataFromApi(() => {
					loadStlModels(stageModels);
				});
			}
		},
		switchSplitView: function () {
			this.isSplitView = !this.isSplitView;
			setTimeout(() => {
				if (this.isSplitView) {
					loadDicom3D();
				}
				viewer.do_resize();
			}, 100);
		},
		switchDicom3dView: function () {
			this.isDicom3DView = !this.isDicom3DView;
			vueApp.$emit("isDicom3DViewChanged", this.isDicom3DView);
			setTimeout(() => {
				if (this.isDicom3DView && !this.isOnlyDicom) {
					loadDicom3D();
				} else if (viewer) {
					viewer.do_resize();
				}
			}, 100);
		},
		loadDicom3DClick: function () {
			loadDicom3D();
		},
		changeZoom: function (factor) {
			viewer.controls.changeZoom(factor);
		},
		showHelp: function () {
			showHelpDialog();
		},
		getMidlineData: function (algo3dToothInfoUrl) {
			if (!algo3dToothInfoUrl && this.zipFile) {
				let filename = this.zipFile.split("/").pop();
				algo3dToothInfoUrl = this.zipFile.replace(
					vueApp.stlCopyUrl,
					vueApp.stlBaseUrl
				).replace(
					filename,
					"algo3d_tooth_info.json"
				);
			}
			if (algo3dToothInfoUrl && !this.midlineData.length) {
				fetch(algo3dToothInfoUrl)
					.then(response => {
						response.text().then(text => {
							var jsonObj = null;
							try {
								jsonObj = JSON.parse(text);
							} catch (e) {
								console.log(`Invalid JSON: ${algo3dToothInfoUrl}! Error: ${e}`);
								sendReport(`Can't load ${algo3dToothInfoUrl}`);
							}
							if (jsonObj) {
								if (!Array.isArray(jsonObj)) {
									console.log(`${algo3dToothInfoUrl} should contain array!`);
									sendReport(`Can't load ${algo3dToothInfoUrl}`);
								} else {
									this.midlineData = jsonObj;
									this.midlineData.forEach(function (data, index) {
										if (data.bbox && Array.isArray(data.bbox)) {
											var minX, minY, minZ, maxX, maxY, maxZ;
											minX = minY = minZ = maxX = maxY = maxZ = 0;

											data.rotated_bbox = [];

											data.bbox.forEach(function (bb) {
												data.rotated_bbox.push(rotatePoint(bb));
												if (bb.x < minX || !minX) minX = bb.x;
												if (bb.x > maxX || !maxX) maxX = bb.x;
												if (bb.y < minY || !minY) minY = bb.y;
												if (bb.y > maxY || !maxY) maxY = bb.y;
												if (bb.z < minZ || !minZ) minZ = bb.z;
												if (bb.z > maxZ || !maxZ) maxZ = bb.z;
											});

											var currentBox = {
												min: {
													x: minX,
													y: minY,
													z: minZ
												},
												max: {
													x: maxX,
													y: maxY,
													z: maxZ
												}
											};
											data.defaultBox = rotateBox(currentBox);
										} else {
											console.log(
												`${data.tooth_no} doesn't contain correct bbox`
											);
										}

										if (
											data.main_axis &&
											Array.isArray(data.main_axis) &&
											data.main_axis.length > 1
										) {
											data.axisPoint1 = rotatePoint(data.main_axis[0]);
											data.axisPoint2 = rotatePoint(data.main_axis[1]);
										} else {
											console.log(
												`${data.tooth_no} doesn't contain correct main_axis`
											);
										}

										if (data.split) {
											data.splitPoint = rotatePoint(data.split);
										} else {
											// TODO : calculate from axisPoint1 and axisPoint2
											// console.log(`${data.tooth_no} doesn't contain split`);
										}
									});
								}
							}
						});
					})
					.catch((error) => {
						// console.log(`Error response for ${algo3dToothInfoUrl}. Error: ${error}`);
						// sendReport(`Can't load ${algo3dToothInfoUrl}`);
					});
				;
			}
		},
		removeItem: function (item) {
			if (item.isTooth) {
				this.removeTooth(item);
			} else {
				let index = this.nerves.indexOf(item);
				if (index >= 0) { // .isDeleted
					console.log("item.isDeleted", item);
					item.isDeleted = true;
					// this.nerves.splice(index, 1);
				}
				index = this.gingivae.indexOf(item);
				if (index >= 0) {
					this.gingivae.splice(index, 1);
				}
				index = this.airways.indexOf(item);
				if (index >= 0) {
					this.airways.splice(index, 1);
				}
				index = this.bones.indexOf(item);
				if (index >= 0) {
					this.bones.splice(index, 1);
				}
			}
		},
		removeTooth: function (item) {
			if (item && item.isTooth) {
				for (let dentation of this.dentations) {
					for (let group of dentation.groups) {
						let index = group.teeth.indexOf(item);
						if (index > -1) { // only splice array when item is found
							group.teeth.splice(index, 1);
							// console.log(`removed tooth file: ${item.filename}`);
						}
					}
				}
			}
		},
		addTooth: function (item) {
			if (item && item.isTooth) {
				let firstSymbol = item.name.substring(0, 1);
				let group = vueApp.allGroups.find((g) =>
					g.name.startsWith(firstSymbol)
				);
				if (!group) {
					group = vueApp.allGroups.find(
						(g) => g.name.trim().toLowerCase() == "other"
					);
				}
				if (group) {
					group.teeth.push(item);
					let dentation = vueApp.dentations.find(d => d.groups.includes(group));
					return dentation;
				} else {
					console.log("!!! tooth group not found", item);
				}
				// for (let dentation of this.dentations) {
				// 	for (let group of dentation.groups) {
				// 		const arr = group.name.split('-');
				// 		if (arr.length == 1 || group.name[0] == item.name[0]) {
				// 			group.teeth.push(item);
				// 			return dentation;
				// 		}
				// 	}
				// }
			}
		},
		applySavedClipData: function () {
			applyClipData(this.savedData.clipData);
		},
		saveListClick: function () {
			this.saveData((result) => {
				if (!result) {
					swal({
						text: "Failed to save changes. Please contact support@cephx.com",
					});
				}
			});
		},
		setImplantName: function (name) {
			this.newImplantName = name;
		},
		setCrownNumber: function (number) {
			this.crownNumber = number;
		},
		setImplantSize: function (length, diameter) {
			stlLogMessage(`setImplantSize: ${length}, ${diameter}`);
			this.newImplantLength = length;
			this.newImplantDiameter = diameter;

			if (this.isResize) {
				var scaleX = diameter / editedImplant.diameter;
				var scaleY = length / editedImplant.length;
				var mesh = viewer.get_model_mesh(editedImplant.id);
				var impl = mesh; //.children[0];
				impl.geometry.scale(scaleX, scaleY, scaleX);
				//impl.position.set(-diameter / 2, -length / 2, -diameter / 2);

				editedImplant.diameter = diameter;
				editedImplant.length = length;
				onCameraChange();
			}
		},
		addImplant: function (implantX, implantY, implantZ, isMaxilla) {
			var implant = {
				id: 0,
				isVisible: true,
				name: this.newImplantName,
				crownId: this.newImplantCrownId,
				length: this.newImplantLength,
				diameter: this.newImplantDiameter,
				defaultLength: this.newImplantLength,
				defaultDiameter: this.newImplantDiameter,
				x: implantX,
				y: implantY,
				z: implantZ,
				isMaxilla: isMaxilla,
				dentition: isMaxilla ? "Maxilla" : "Mandible",
				isLoaded: false,
				isFromData: false,
				isImplant: true,
				color: vueApp.implantsColor
			};
			this.newImplantCrownId = null;
			implant.id = vueApp.generateNewItemId();
			this.implants.push(implant);
			$("#globalSpinner").css({ display: "block" });
			stlLogMessage(
				`addImplant: ${this.newImplantName}, ${implantX}, ${implantY}, ${implantZ}`
			);
			addImplantStl(implant);
		},
		loadImplant: function (item) {
			if (item) {
				//console.log(item);
				var implant = {
					isVisible: true,
					name: item.name,
					length: item.length,
					diameter: item.diameter,
					defaultLength: item.length,
					defaultDiameter: item.diameter,
					focusCameraPosition: item.focusCameraPosition,
					x: item.x,
					y: item.y,
					z: item.z,
					rotationX: item.rotationX,
					rotationY: item.rotationY,
					rotationZ: item.rotationZ,
					isMaxilla: item.isMaxilla,
					dentition: item.isMaxilla ? "Maxilla" : "Mandible",
					isLoaded: false,
					isFromData: true,
					isImplant: true,
					color: this.implantsColor,
					newRotation: item.newRotation
				};

				if (item.defaultPosition) {
					implant.x = item.defaultPosition.x;
					implant.y = item.defaultPosition.y;
					implant.z = item.defaultPosition.z;
				}

				if (item.defaultRotation) {
					implant.rotationX = item.defaultRotation._x;
					implant.rotationY = item.defaultRotation._y;
					implant.rotationZ = item.defaultRotation._z;
				}

				// if (item.id > 0) {
				// 	implant.id = item.id;
				// }
				implant.id = vueApp.generateNewItemId();

				this.implants.push(implant);
				stlLogMessage(`loadImplant: ${implant.id}, ${implant.name}`);
				addImplantStl(implant);
			}
		},
		addCrown: function (implantX, implantY, implantZ, isMaxilla) {
			var crown = {
				id: this.generateNewItemId(),
				number: this.crownNumber,
				name: `Crown ${this.crownNumber}`,
				implantId: this.crownImplantId,
				implant: null,
				isVisible: true,
				x: implantX,
				y: implantY,
				z: implantZ,
				isMaxilla: isMaxilla,
				dentition: isMaxilla ? "Maxilla" : "Mandible",
				isLoaded: false,
				isFromData: false,
				stlModelLoaded: null,
				isCrown: true,
				color: vueApp.crownsColor
			};

			this.crownImplantId = null;
			this.crownNumber = null;
			this.crowns.push(crown);
			$("#globalSpinner").css({ display: "block" });
			stlLogMessage(
				`addCrown: ${crown.id}, ${crown.name}, ${implantX}, ${implantY}, ${implantZ}`
			);
			addCrownStl(crown);
		},
		loadCrown: function (crown) {
			if (crown) {
				crown.isLoaded = false;
				crown.isFromData = true;
				crown.isCrown = true;
				crown.color = vueApp.crownsColor;
				this.crowns.push(crown);
				stlLogMessage(`loadCrown: ${crown.id}, ${crown.name}`);
				addCrownStl(crown);
			}
		},
		resizeImplant: function () {
			console.log("resizeImplant");
			this.isResize = true;
			initStep2(this.lengths, this.diameters);
		},
		getItemById: function (id, guid) {
			let item = guid ? this.allItems.find(x => x.guid === guid) : null;
			if (!item) {
				item = id ? this.allItems.find(x => x.id === id) : null;
				// console.log("id item", item);
			} else {
				// console.log("guid item", item);
			}
			return item;
		},
		getItemByGuid: function (guid) {
			return guid ? this.allItems.find(x => x.guid === guid) : null;
		},
		getItemByFilename: function (filename) {
			let retval = null;
			if (filename) {
				// retval = this.allItems.find(x => x.newFileName === filename);
				// if (!retval)
				retval = this.allItems.find(x => x.filename === filename);
			}
			return retval;
		},
		getItemByMeshUuid: function (uuid) {
			return uuid ? this.allItems.find(x => x.uuid === uuid) : null;
		},
		generateNewItemId: function () {
			var allIds = this.allItems.map(function (item) {
				return item.id;
			});
			var maxId = Math.max.apply(null, allIds);
			return maxId + 1;
		},
		generateAddedTag: function (toothNumber) {
			let addedTag = "added";
			let existed = vueApp.getToothByAddedTag(toothNumber, addedTag);
			let i = 1;
			while (existed != null) {
				addedTag = `added(${i})`;
				existed = vueApp.getToothByAddedTag(toothNumber, addedTag);
				i++;
			}
			return addedTag;
		},
		getToothByName: function (name) {
			return this.allTeeth.find(x => x.name === name);
		},
		getToothByNumber: function (number) {
			number = +number;
			return this.allTeeth.find(x => x.number === number);
		},
		getToothByAddedTag: function (number, tag) {
			return this.allTeeth.find(x => x.number === number && x.addedTag === tag);
		},
		getToothByFileName: function (fileName) {
			return this.allTeeth.find(x => x.filename === fileName);
		},
		getToothByUuid: function (uuid) {
			return uuid ? this.allDents.find(x => x.uuid === uuid) : null;
		},
		getLastMolars: function (isMaxilla) {
			var tooth1 = null;
			var tooth2 = null;
			var teeth = this.allTeeth.filter(tooth => tooth.isMaxilla === isMaxilla);
			teeth.forEach(tooth => {
				if (isMaxilla) {
					if (tooth.number === 18 || (!tooth1 && tooth.number === 17)) {
						tooth1 = tooth;
					}
					if (tooth.number === 28 || (!tooth2 && tooth.number === 27)) {
						tooth2 = tooth;
					}
				} else {
					if (tooth.number === 48 || (!tooth1 && tooth.number === 47)) {
						tooth1 = tooth;
					}

					if (tooth.number === 38 || (!tooth2 && tooth.number === 37)) {
						tooth2 = tooth;
					}
				}
			});
			return tooth1 && tooth2 ? [tooth1, tooth2] : null;
		},
		getFirstIncisor: function (positionNumber) {
			var toothNumber = 0;
			if (positionNumber < 21) {
				toothNumber = 11;
			} else if (positionNumber < 31) {
				toothNumber = 21;
			} else if (positionNumber < 41) {
				toothNumber = 31;
			} else {
				toothNumber = 41;
			}
			return this.getToothByNumber(toothNumber);
		},
		getMaxOrthoStageId: function () {
			let allIds = vueApp.orthoStages.map(function (item) {
				return item.id ? item.id : 0;
			});
			let maxId = allIds.length > 0 ? Math.max.apply(null, allIds) : 0;
			return maxId;
		},
		getMaxTreatmentStageId: function () {
			let allIds = vueApp.treatmentStages.map(function (item) {
				return item.id ? item.id : 0;
			});
			let maxId = allIds.length > 0 ? Math.max.apply(null, allIds) : 0;
			return maxId;
		},
		saveData: function (callback) {
			updateSavedData();
			saveViewerData(callback);
		},

		showMarketing: function () {
			// this.showmarketingprompt = true;
			if (this.showmarketingprompt) {
				this.startmarketingprompt = true;
			}
		},
		leaveModes: function (toDefaultView, stayInOcclusal, preserveView) {
			vueApp.unfocusAll();
			if (vueApp.activeMode && vueApp.activeMode.leaveMode) {
				var activeMode = vueApp.activeMode;
				vueApp.activeMode = null;
				activeMode.leaveMode(true);
			}

			$("#anglePanel").css("display", "none");
			$(".ortho-controls").css("display", "none");

			if (vueApp.isTreatmentPlayMode) {
				restoreDefaultGeometries();
				vueApp.isTreatmentPlayMode = vueApp.isTreatmentPlaying = false;
				$("#teethListBtn").css("display", "block");
				$("#teethListContainer").css("display", "block");

				// vueApp.unfocusAll();
				// vueApp.resetVisibilityAndOpacity();
				// vueApp.switchToDefaultView();
				// vueApp.$emit("visibilityChanged", "multiselect reset");
			}

			leaveOpacityMode();
			leaveColorMode();
			leaveHideMode();

			enableImplantsMenu();

			if (!preserveView && (!stayInOcclusal || !vueApp.isOcclusal)) {
				vueApp.resetVisibilityAndOpacity();
			}

			return;

			if (toDefaultView || (!stayInOcclusal && vueApp.isOcclusal)) {
				vueApp.switchToDefaultView();
				vueApp.isOcclusal = false;
			}
		},
		resetVisibilityAndOpacity: function (showInvisible) {
			vueApp.allItems.forEach(function (model) {
				model.isHidden = false;
				if (showInvisible)
					model.isVisible = true;
				if (model.isVisible) {
					let color = vueApp.getActualColor(model);
					itemVisibilityChanged(model, color);
					let opacity = model.opacity ? model.opacity : 1;
					if (!model.extracted)
						viewer.set_opacity(model.id, opacity);
				} else {
					viewer.set_color(model.id, "transparent");
				}
			});
			vueApp.allTeeth.forEach((model) => {
				let mesh = viewer.get_model_mesh(model.id);
				if (mesh && mesh.rootCrownMaterials && mesh.originalMaterial) {
					mesh.material = vueApp.showTeethRoots ? mesh.rootCrownMaterials : mesh.originalMaterial;
				}
				// let material = mesh.originalMaterial ? mesh.originalMaterial : mesh.material;
				// material.side = THREE.DoubleSide;
			});
		},
		unfocusAll: function () {
			let focusedTooth = this.getFocusedTooth();
			if (focusedTooth) {
				unfocusItem(focusedTooth);
			}
		},
		switchToDefaultView: function () {
			if (vueApp.savedData && vueApp.savedData.cameraTarget) {
				this.lookAtPoint(vueApp.savedData.cameraTarget);
			} else {
				if (defaultBox && defaultBox.center) {
					this.lookAtPoint(defaultBox.center);
				} else {
					this.lookAtPoint({ x: 0, y: 0, z: 0 });
				}
			}
			// console.log(vueApp.savedData);
			resetCameraUp();

			if (vueApp.savedData && vueApp.savedData.cameraPosition) {
				viewer.camera.position.copy(vueApp.savedData.cameraPosition);
			} else {
				if (defaultBox && defaultBox.center) {
					viewer.camera.position.x = defaultBox.center.x;
					viewer.camera.position.y = defaultBox.center.y;
				}
				else {
					viewer.camera.position.x = 0;
					viewer.camera.position.y = 0;
				}
				viewer.camera.position.z = defaultZoom;
			}

			viewer.camera.updateProjectionMatrix();
			viewer.controls.update();
			vueApp.isOcclusal = false;
			viewer.controls.dispatchChangeAfterDelay(100);
		},
		saveCameraView: function () {
			this.savedCameraView =
			{
				cameraPosition: new THREE.Vector3(0, 0, 0),
				cameraTarget: new THREE.Vector3(0, 0, 0),
				color: viewer.scene.background
			};
			this.savedCameraView.cameraPosition.copy(viewer.camera.position);
			this.savedCameraView.cameraTarget.copy(viewer.controls.target);

		},
		switchToSavedCameraView: function () {
			if (this.savedCameraView) {
				viewer.scene.background = this.savedCameraView.color;
				this.lookAtPoint(this.savedCameraView.cameraTarget);

				resetCameraUp();
				viewer.camera.position.copy(this.savedCameraView.cameraPosition);

				viewer.camera.updateProjectionMatrix();
				viewer.controls.update();
				viewer.controls.dispatchChangeAfterDelay(100);
			}
		},
		lookAtPoint: function (point) {
			viewer.camera.lookAt(point.x, point.y, point.z);
			viewer.controls.target = new THREE.Vector3(point.x, point.y, point.z);
			viewer.camera.updateProjectionMatrix();
			viewer.controls.update();
			viewer.controls.dispatchChangeAfterDelay(100);
		},
		getActualColor: function (model) {
			let color = "#FFFFFF";
			if (model) {
				if (model.tempColor) {
					color = model.tempColor;
				}
				else {
					color =
						vueApp.isRandomTeethColor &&
							model.randomColor &&
							model.randomColor != noRandomColor
							? model.randomColor
							: model.color;
				}
			}
			return color;
		},
		isTeethListOpen: function () {
			// let display = document.getElementById('teethListBtn').style.display;
			let teethListBtnVisible = document.getElementById('teethListBtn').checkVisibility();
			return teethListBtnVisible && $(`#teethListPanel`).hasClass("show");
		},
		getFocusedTooth: function () {
			return this.allTeeth.find(t => t.isFocused);
		},

		afterStlLoad: async function () {
			// createPca(1000, viewer.scene);

			let totalCount = vueApp.allItems.length;
			let teethCount = vueApp.allTeeth.length;
			console.log("totalCount", totalCount, "teethCount", teethCount);

			if (viewer) {
				viewer.controls.keysEnabled = false;
			}

			if (vueApp.bones.length > 1) {
				vueApp.hasFullBones = await checkHasFullBones();

				fetchMandibleTransform();
				if (vueApp.hasSolidBones) {
					await switchBonesType("solid");
				}
			}

			if (teethCount > 0) {
				vueApp.downloadingStages = true;
				vueApp.savedReports = await sendGetCutReportsRequest();
				vueApp.hasReports = vueApp.savedReports && vueApp.savedReports.length > 0;

				// loadTreatmentMatrixs();
				$("#orthoMenu").css({ display: "none" });
				downloadOrhoStages((stages) => {
					vueApp.downloadingStages = false;
					$("#orthoMenu").removeAttr("style");
					if (stages && stages.length) {
						let sorted = stages.sort((a, b) => a.id - b.id);
						sorted.forEach(stage => {
							vueApp.orthoStages.push(stage);
						});
					}
				}, false);
			}

			if (teethCount > 0 && vueApp.airways.length == 0 && vueApp.bones.length == 0 && vueApp.nerves.length == 0 && vueApp.gingivae.length == 0) {
				vueApp.isOnlyTeeth = true;
			}

			if (teethCount < 1) {
				vueApp.isNoTeeth = true;
				$("#orthoMenu").css({ display: "none" });

				// $(".menu3d").css({ display: "none" });
			}

			if (totalCount > 1 || (totalCount == 1 && vueApp.airways.length == 0)) {
				$(`#teethListContainer`).css({
					display: "block",
				});

				var isMobileOrTablet = mobileAndTabletCheck();
				if (!isMobileOrTablet) {
					$(`#teethListPanel`).addClass("show");
				}
			}

			if (teethCount > 0) {
				vueApp.allTeeth.forEach(tooth => {
					let mesh = viewer.get_model_mesh(tooth.id);
					if (mesh)
						mesh.cbctGeometry = mesh.geometry;
				});

				if (vueApp.isStitched && !vueApp.isStitching) {
					// vueApp.viewSourceType = vueApp.savedData.viewSourceType ? vueApp.savedData.viewSourceType : "stitched";
					vueApp.viewSourceType = "stitched";
					switchStitching(vueApp.viewSourceType);
				} else {
					// vueApp.viewSourceType = vueApp.savedData.viewSourceType ? vueApp.savedData.viewSourceType : "cbct";
					vueApp.viewSourceType = "cbct";
				}

				// if (vueApp.bones.length) { 
				// 	generateRootCrownMeshes();
				// }
			}

			vueApp.$on("visibilityChanged", (item) => {
				visibilityChangedHandler(item);
			});

			await loadDicomUrls();
			await checkHasDicom();

			if (vueApp.generateReportName) {
				await generateReport(vueApp.generateReportName)
			}
		},

		reloadAppFromUrl: function (jsonUrl) {
			if (vueApp.fromShareLink) {
				let params = {
					jsonLocation: jsonUrl,
					readonly: vueApp.isViewMode,
					resetCase: vueApp.isReset,
					allowDownloads: vueApp.allowDownloads,
					isExpired: vueApp.isExpired,
					cbct: vueApp.isCbctParam,
				};
				if (vueApp.recepientName)
					params.rname = vueApp.recepientName;
				if (vueApp.recepientEmail)
					params.remail = vueApp.recepientEmail;
				let paramsString = JSON.stringify(params);
				let b64 = utf8_to_b64(paramsString);
				location.href = `${location.origin}${location.pathname}?p=${b64}`;
			} else {
				location.href = `${location.origin}${location.pathname}?json_location=${jsonUrl}`;
			}
			return;

			allLoaded = stlShown = false;
			if (viewer) {
				viewer.controls.removeEventListener('change', onCameraChange);
				viewer.clean();
				viewer.renderer.domElement.remove();
				viewer = null;
			}

			if (ioViewer) {
				ioViewer.clean();
				ioViewer.renderer.domElement.remove();
				ioViewer = null;
			}

			$(`#teethListPanel`).removeClass("show");
			$id('loader').style.display = 'block';
			$id('stl_cont').style.visibility = 'hidden';
			vueApp.isStlLoaded = false;
			// $("#bottomPanel").css("display", "none");
			// vueApp.initApp(vueApp.baseObj);

			init(false, jsonUrl);
		},
		hideClipping: function () {
			if (viewer) {
				viewer.renderer.clippingPlanes = empty;
			}
		},
		restoreClipping: function () {
			if (viewer) {
				viewer.renderer.clippingPlanes =
					vueApp.savedData.clipData && vueApp.savedData.clipData.isEnabled
						? globalPlanes
						: empty;
			}
		}
	},
	computed: {
		isHighlightEnabled: function () {
			return !this.activeMode || !this.activeMode.noHighlight;
		},
		allGroups: function () {
			var groups = this.dentations.reduce(function (a, b) {
				return a.concat(b.groups);
			}, []);
			return groups.length > 0 ? groups.sort(sortByName) : groups;
		},
		allTeeth: function () {
			let teeth = this.allGroups.reduce(function (a, b) {
				return a.concat(b.teeth);
			}, []);
			teeth = teeth.sort(function (a, b) {
				if (a.savedFileName && b.savedFileName)
					return a.savedFileName.localeCompare(b.savedFileName);
				else
					return a.savedNumber - b.savedNumber;
			});
			return teeth;
		},
		upperTeeth: function () {
			return this.allTeeth.filter(t => t.isUpper);
		},
		lowerTeeth: function () {
			return this.allTeeth.filter(t => !t.isUpper);
		},
		allItems: function () {
			return this.bones
				.concat(this.nerves)
				.concat(this.gingivae)
				.concat(this.airways)
				.concat(this.allTeeth)
				.concat(this.implants)
				.concat(this.crowns);
		},
		teethMeshes: function () {
			return this.allTeeth.map(t => viewer.get_model_mesh(t.id));
		},
		allMeshes: function () {
			return this.bones
				.concat(this.nerves)
				.concat(this.gingivae)
				.concat(this.airways)
				.concat(this.allTeeth)
				.concat(this.implants)
				.concat(this.crowns).map(model => viewer.get_model_mesh(model.id));
		},
		allDents: function () {
			return this.allTeeth.concat(this.implants).concat(this.crowns);
		},
		maxillaBone: function () {
			return this.bones.find(b => b.isMaxilla);
		},
		mandibleBone: function () {
			return this.bones.find(b => !b.isMaxilla);
		},
		cbctStages: function () {
			return this.orthoStages.filter((stage) => !stage.isIntraoral);
		},
		intraoralStages: function () {
			return this.orthoStages.filter((stage) => stage.isIntraoral);
		},
		currentStages: function () {
			let retval = this.orthoStages.filter((stage) => stage.isIntraoral == this.isIntraoralView);
			// console.log("currentStages", retval);
			return retval;
		}
	},
	mounted: function () { }
};

//#region Fields

let isMouseDown = false;
let mouseDownEvent = null;
let highlightedTooth = null;

let cbctMenu = null;
let cbctColorBtn = null;
let cbctChangeBtn = null;
let cbctDeleteBtn = null;
let cbctFocusBtn = null;
let cbctFocusDicomBtn = null;
let cbctHideBtn = null;
let cbctResetInitialBtn = null;
let cbctResetCurrentBtn = null;

let selectedTooth = null;
let taggedControl = null;

//#endregion

window.addEventListener("DOMContentLoaded", function () {
	console.log(cephxVersion, new Date());

	const urlParams = new URLSearchParams(window.location.search);
	const defaultParam = urlParams.get("default");
	const lqParam = urlParams.get("lq");
	if (lqParam && lqParam === "true") {
		vueApp.isHighQuality = false;
	}

	const demoParam = urlParams.get("demo");
	if (demoParam !== null) {
		vueApp.isDemo = true;
	}

	const engineerParam = urlParams.get("engineerMode");
	if (engineerParam !== null) {
		vueApp.isEngineerMode = true;
	}

	const sharedParams = urlParams.get("p");
	if (sharedParams) {
		vueApp.fromShareLink = true;
		vueApp.isShareEnabled = false;
		var jsonParams = b64_to_utf8(sharedParams);
		var params = JSON.parse(jsonParams);
		vueApp.jsonLocation = params.jsonLocation;
		console.log("jsonParams", params);
		vueApp.isViewMode = params.readonly;
		vueApp.isReset = params.resetCase;
		vueApp.allowDownloads = params.allowDownloads;
		vueApp.isExpired = params.isExpired;
		vueApp.isAnonymized = params.anonymized === undefined || params.anonymized;

		if (params.generateReport && params.generateReport.trim())
			vueApp.generateReportName = params.generateReport;

		if (params.cbct)
			vueApp.isCbctParam = params.cbct;
		if (params.rname) {
			vueApp.recepientName = params.rname;
		}
		if (params.remail) {
			vueApp.recepientEmail = params.remail;
		}
	} else {
		vueApp.jsonLocation = urlParams.get("json_location");
		vueApp.isViewMode = urlParams.get("save") === "false";
		const reset = urlParams.get("reset");
		vueApp.isReset = reset && reset.toLowerCase() == "true";

		const cbctParam = urlParams.get("cbct");
		vueApp.isCbctParam = cbctParam && cbctParam === "true";

		const isExpiredParam = urlParams.get("isExpired");
		vueApp.isExpired = isExpiredParam && isExpiredParam === "true";
	}

	if (vueApp.isExpired || !vueApp.jsonLocation) {
		$(".teeth-list-ctrl").css("display", "none");
		$("#orthoMenu").css({ display: "none" });
		$("#viewSubMenu").css({ display: "none" });

		// $("#stl_menu").css("disabled", "disabled");
		if (vueApp.isExpired)
			swal({
				text: "Link expired. Please request another link",
			});

		vueApp.isExpired = true;
		return;
	}

	const generateReportParam = urlParams.get("generateReport");
	if (!vueApp.generateReportName && !!generateReportParam && !!generateReportParam.trim()) {
		vueApp.generateReportName = generateReportParam;
	}

	vueApp.showmarketingprompt = urlParams.get("showmarketingprompt") === "true";
	var temp = urlParams.get("opennewtabprompt");
	if (temp) {
		vueApp.opennewtabprompt = temp;
	}

	if (window.caches) {
		window.caches.open("cephxStlCache").then(function (cache) {
			vueApp.cache = cache;
			init(defaultParam, vueApp.jsonLocation);
		});
	} else {
		init(defaultParam, vueApp.jsonLocation);
	}

	$(window).resize(function (e) {
		onCameraChange();
	});

	$("#main_div").on("contextmenu", "img", function (e) {
		return false;
	});

	// $("li.dropdown")
	$("a.nav-link").on("mousedown", function () {
		$(".secondary-menu").removeClass("show");
	});

	stl_cont = document.getElementById("stl_cont");
	if (isTouchEnabled()) {
		stl_cont.addEventListener("touchstart", function (e) {
			var event = e.targetTouches[0];
			onDocumentMouseDown(event);
		});
		stl_cont.addEventListener("touchmove", function (e) {
			var event = e.targetTouches[0];
			onDocumentMouseMove(event);
		});
		stl_cont.addEventListener("touchend", function (e) {
			var event = e.changedTouches[0];
			onDocumentMouseUp(event);
		});
	} else {
		//stl_cont.addEventListener("click", onDocumentClick, false);
		stl_cont.addEventListener("mousedown", onDocumentMouseDown, false);
		stl_cont.addEventListener("mousemove", onDocumentMouseMove, false);
		stl_cont.addEventListener("mouseup", onDocumentMouseUp, false);
		stl_cont.addEventListener("dblclick", onDocumentDblClick, false);

		cbctMenu = document.getElementById("cbct-tooth-menu");
		stl_cont.appendChild(cbctMenu);

		cbctColorBtn = document.getElementById("cbct-color-btn");
		cbctColorBtn.addEventListener("click", () => {
			cbctMenu.style.display = "none";
			if (selectedTooth)
				openColorPicker(selectedTooth.id)
		});

		cbctChangeBtn = document.getElementById("cbct-change-btn");
		cbctChangeBtn.addEventListener("click", () => {
			cbctMenu.style.display = "none";
			editItemSettings(selectedTooth);
		});

		cbctFocusDicomBtn = document.getElementById("cbct-focus-dicom-btn");
		cbctFocusDicomBtn.addEventListener("click", (event) => {
			cbctMenu.style.display = "none";
			focusDicomItem(selectedTooth);
		});

		cbctFocusBtn = document.getElementById("cbct-focus-btn");
		cbctFocusBtn.addEventListener("click", (event) => {
			// if (event.stopPropagation) {
			// 	event.stopPropagation();
			// 	event.preventDefault();
			// }
			cbctMenu.style.display = "none";
			if (!selectedTooth.isFocused)
				focusItem(selectedTooth);
			else
				unfocusItem();
		});

		cbctHideBtn = document.getElementById("cbct-hide-btn");
		cbctHideBtn.addEventListener("click", () => {
			cbctMenu.style.display = "none";
			if (selectedTooth) {
				selectedTooth.isVisible = !selectedTooth.isVisible;
				itemVisibilityChanged(selectedTooth, selectedTooth.color, vueApp.teethOpacity);
			}
		});

		cbctDeleteBtn = document.getElementById("cbct-delete-btn");
		cbctDeleteBtn.addEventListener("click", () => {
			cbctMenu.style.display = "none";
			deleteItem(selectedTooth);
		});

		cbctResetInitialBtn = document.getElementById("cbct-reset-initial-btn");
		cbctResetInitialBtn.addEventListener("click", () => {
			cbctMenu.style.display = "none";
			console.log("cbctResetInitialBtn");
			resetToInitial(selectedTooth);
		});

		cbctResetCurrentBtn = document.getElementById("cbct-reset-current-btn");
		cbctResetCurrentBtn.addEventListener("click", () => {
			cbctMenu.style.display = "none";
			console.log("cbctResetCurrentBtn");
			resetToCurrent(selectedTooth);
		});
	}

	const loader = new THREE.FontLoader();
	loader.load('fonts/helvetiker_regular.typeface.json', function (font) {
		vueApp.defaultFont = vueApp.helvetikerFont = font;
	});

	loader.load('fonts/droid_sans_mono_regular.typeface.json', function (font) {
		vueApp.droidMonoFont = font;
	});
});

function onDocumentDblClick(event) {
	updateRaycaster(event);
	selectedTooth = intersectTooth(null, event);
	// console.log("onDocumentDblClick", selectedTooth);
	if (selectedTooth) {
		cbctHideBtn.style.display =
			selectedTooth.isVisible ? "initial" : "none";

		cbctResetInitialBtn.style.display =
			cbctResetCurrentBtn.style.display =
			vueApp.activeMode == opmode ? "initial" : "none";

		cbctFocusDicomBtn.style.display =
			vueApp.isDicomOpen ? "initial" : "none";

		cbctFocusBtn.innerHTML = selectedTooth.isFocused ? "Unfocus Tooth" : "Focus Tooth";
		cbctMenu.style.display = "initial";
		cbctMenu.style.left = event.offsetX + 1 + "px";
		cbctMenu.style.top = event.offsetY + 1 + "px";
	} else {
		var inMode =
			vueApp.activeMode &&
			vueApp.activeMode.isActive &&
			vueApp.activeMode.doubleClick;
		if (inMode)
			vueApp.activeMode.doubleClick(event);
	}
}

function isTouchEnabled() {
	return ('ontouchstart' in window) ||
		(navigator.maxTouchPoints > 0) ||
		(navigator.msMaxTouchPoints > 0);
}

async function init(defaultParam, jsonLocation) {
	if (defaultParam && defaultParam === "true") {
		initModel(defaultObject);
	} else if (jsonLocation) {
		if (jsonLocation.endsWith("dicom.json")) {
			console.log("!!! dicom.json");
			try {
				let tempLocation = jsonLocation.replace("dicom.json", "zipinput.json");
				let response = await fetch(tempLocation, { method: "HEAD" });
				if (response.status === 200) {
					jsonLocation = vueApp.jsonLocation = tempLocation;
				}
			} catch (error) {
				console.log("!!! dicom.json", error);
			}
		}

		fetch(jsonLocation, {
			cache: "no-cache"
		})
			.then(function (response) {
				response.text().then(async (text) => {
					let model = JSON.parse(text);
					// console.log("model 1", model);
					if (model.data && !model.data.areGuidsSet && model.data.desktopZip) {
						let tempModel = await sendSetGuidsRequest();
						if (tempModel)
							model = tempModel;
					}
					await setS3BaseUrls(true);

					// console.log("model 2", model);
					initModel(model);
				});
			})
			.catch(error => {
				console.error("Error in main JSON download: ", error);
			});
	} else {
		// $id("open_json").style.display = "block";
		vueApp.showMarketing();
	}
}

async function setS3BaseUrls(fromInit) {
	let baseUrl = vueApp.zipFile ? vueApp.zipFile : vueApp.jsonLocation;
	let arr = baseUrl.split("/");
	arr.pop();
	vueApp.s3dicom = arr[arr.length - 1];
	vueApp.stlBaseUrl = arr.join('/');
	const index = arr.indexOf('STL');
	arr.splice(index, 1);
	vueApp.s3Url = arr.slice(0, arr.length - 1).join('/'); // https://d3lk8scmwriwsa.cloudfront.net 
	// console.log("s3Url: ", vueApp.s3Url);
	vueApp.dicomUrl = arr.join('/');
	if (!fromInit) {
		console.log("setS3BaseUrls: ", vueApp.s3dicom, vueApp.stlBaseUrl);
		//, vueApp.stlBaseUrl, vueApp.s3Url, vueApp.dicomUrl);
		if (vueApp.zipFile)
			await checkIsStitched();
		// await checkHasDicom();
	}
}

function findTaggedControl(tagParam = "group", isHighlight, isShift, cursor, isMouseDown) {
	// need precall -  updateRaycaster(event);
	let combinedArray = [];
	let taggedMeshes = [];
	viewer.scene.children.forEach(element => {
		if (element.tag == tagParam) {
			taggedMeshes.push(...element.children);
			if (element.isMesh)
				taggedMeshes.push(element);
		}
	});
	combinedArray = taggedMeshes.filter(m => m.tag);
	// combinedArray.filter(x => !x.geometry.boundingSphere).forEach(x=> x.geometry.computeBoundingSphere());
	// console.log("findTaggedControl", tagParam, combinedArray.length, isMouseDown);
	// combinedArray.push(...taggedMeshes);
	// let visibleTeeth = vueApp.allTeeth.filter((t) => t.isVisible);
	// let visibleTeethMeshes = visibleTeeth.map(t => viewer.get_model_mesh(t.id))
	// 	.filter((mesh) => mesh && mesh.visible);
	// combinedArray.push(...visibleTeethMeshes);
	let intersects = raycaster.intersectObjects(combinedArray); // , true
	let intersectPoint = null;
	let intersectTagged = null;
	// intersectTagged = intersects.find(intersect => {
	// 	intersectPoint = intersect.point;
	// 	return intersect.object.tag != undefined;
	// });

	let intersectFirst = intersects.length > 0 ? intersects[0] : null;
	if (intersectFirst && intersectFirst.object.tag != undefined) {
		intersectPoint = intersectFirst.point;
		intersectTagged = intersectFirst;
	}

	if (taggedControl != intersectTagged) {
		taggedMeshes.forEach((child) => {
			if (child.defaultColor) {
				child.material.color = new THREE.Color(child.defaultColor);
			}
		});
		document.body.style.cursor = "default";

		if (intersectTagged) {
			document.body.style.cursor = cursor;
			let intersectMesh = intersectTagged.object;
			if (intersectMesh.defaultColor)
				intersectMesh.material.color = new THREE.Color(0xffff00);
		}
		taggedControl = intersectTagged;
	}

	if (intersectTagged && !isHighlight && vueApp.activeMode.tagDetected)
		vueApp.activeMode.tagDetected(intersectTagged.object.tag, intersectTagged.object, isShift, intersectPoint);

	return intersectTagged;
}

function onDocumentMouseDown(event) {
	if (cbctMenu && cbctMenu.style && cbctMenu.style.display == "initial") {
		return;
	}
	isMouseDown = true;
	mouseDownEvent = event;
	if (event.button && event.button > 0) {
		return;
	}
	var inMode =
		vueApp.activeMode &&
		vueApp.activeMode.isActive &&
		(vueApp.activeMode.toothSelected ||
			vueApp.activeMode.tagDetected ||
			vueApp.activeMode.mouseDown);
	if (inMode) {
		if (vueApp.activeMode.mouseDown) {
			vueApp.activeMode.mouseDown(event);
		} else {
			updateRaycaster(event);
			// var selectedId = vueApp.activeMode.selectedId;
			// if (selectedId) {
			const isShift = event.shiftKey;
			// console.log("isShift", isShift);
			let tag = vueApp.activeMode.modeTag;
			if (!tag) tag = "group";
			let cursor = vueApp.activeMode.modeCursor;
			if (!cursor) cursor = "pointer";
			var tagged = findTaggedControl(tag, false, isShift, cursor, true);
			if (tagged) return true;
			// }
		}
	}
	return false;
}

function onDocumentMouseMove(event) {
	try {
		if (vueApp.isHidden) return;

		if (cbctMenu.style.display == "initial") {
			return;
		}

		let needHighlight = false;
		if (
			vueApp.activeMode &&
			vueApp.activeMode.isActive &&
			vueApp.activeMode.mouseMove
		) {
			needHighlight = vueApp.activeMode.mouseMove(event);
		}

		if (
			(vueApp.isColorMode && !teethColorMouseDown) ||
			vueApp.isHideMode ||
			needHighlight ||
			vueApp.isDicomOpen ||
			vueApp.isTeethListOpen()
		) {
			if ((event.buttons && event.buttons > 0) || vueApp.getFocusedTooth()) {
				return;
			}
			updateRaycaster(event);
			if (vueApp && vueApp.activeMode && vueApp.activeMode.tagDetected) {
				let tag = vueApp.activeMode.modeTag;
				if (!tag) tag = "group";
				let cursor = vueApp.activeMode.modeCursor;
				if (!cursor) cursor = "pointer";
				findTaggedControl(tag, true, false, cursor);
			}
			var tooth = intersectTooth(null, event);
			if (highlightedTooth != tooth) {
				if (tooth && vueApp.isHighlightEnabled) {
					highlightedTooth = tooth;
					if (!vueApp.isHideMode)
						highlightedTooth.isHovered = true;
					setHighlightedToothColor(highlightedTooth);
				}
				if (highlightedTooth && vueApp.isHighlightEnabled) {
					vueApp.allTeeth.forEach(function (model) {
						if (model != tooth) {
							if (!vueApp.isHideMode)
								model.isHovered = false;
							if ((model.isVisible || vueApp.isHideMode) && !model.isHidden && !model.extracted) {
								let color = vueApp.getActualColor(model);
								viewer.set_color(model.id, color);
							}
						}
					});
					highlightedTooth = tooth;
				}
				if (vueApp.activeMode && vueApp.activeMode.toothEnter) {
					vueApp.activeMode.toothEnter(highlightedTooth);
				}

				if (vueApp.isDicomOpen) {
					highlightOutlines(highlightedTooth);
				}
			}
		}
	} catch (error) {
		console.log("onDocumentMouseMove", error);
	}
}

function onDocumentMouseUp(event) {
	document.body.style.cursor = "default";
	if (cbctMenu && cbctMenu.style) {
		cbctMenu.style.display = "none";
	}
	$("#anglePanel").fadeOut();
	updateRaycaster(event);
	var tooth = intersectTooth(null, event);
	if (tooth) {
		tooth.isClicked = true;
	}

	let needClick = false;
	if (vueApp.activeMode && vueApp.activeMode.isActive) {
		if (vueApp.activeMode.mouseUp) {
			needClick = vueApp.activeMode.mouseUp(event);
		}
		needClick = needClick || vueApp.activeMode.toothSelected;
	}

	if (vueApp.isColorMode || vueApp.isHideMode || needClick) {
		if (event.button && event.button > 0) {
			return;
		}
		if (isMouseDown) {
			var distance = calculateEventDistance(mouseDownEvent, event);
			if (distance < 1) {
				if (vueApp.isColorMode || vueApp.isHideMode) {
					if (tooth) {
						onToothUp(tooth);
						// if (event.stopPropagation) {
						// 	event.stopPropagation(); //	event.preventDefault();
						// }
					}
				} else {
					if (vueApp.activeMode.toothSelected) {
						vueApp.activeMode.toothSelected(tooth, event);
					}
					if (vueApp.activeMode.mouseClick) {
						vueApp.activeMode.mouseClick(event);
					}
				}
			}
		}
	}
	isMouseDown = false;
}

function onToothUp(item) {
	if (!item)
		return;
	if (vueApp.isHideMode) {
		item.isVisible = !item.isVisible;
		viewer.set_opacity(item.id, item.isVisible ? 1 : 0.3); // 2.1 - 2.2
		// viewer.set_color(item.id, hideModeTeethColor);
		vueApp.$emit('visibilityChanged', item);
	} else if (vueApp.isColorMode) {
		if (item.isVisible) {
			setTimeout(function () {
				openColorPicker(item.id);
			}, 100);
		}
	}
}

function calculateEventDistance(event1, event2) {
	var x1 = event1.clientX;
	var x2 = event2.clientX;
	var a = x1 - x2;
	var y1 = event1.clientY;
	var y2 = event2.clientY;
	var b = y1 - y2;
	return Math.hypot(a, b); //Math.sqrt(a*a + b*b);
}

export {
	findTaggedControl, isTouchEnabled
};

</script>

<style>
@import "css/editControls.css";

#isStitchingHint {
	width: 250px;
	top: 7px;
	right: 25px;
	position: absolute;
	background-color: transparent;
	color: white;
	/* font-weight: bold; */
	text-align: center;
	font-size: 16px;
	font-family: Montserrat, sans-serif;
}

.progress-small-img {
	display: inline;
	width: 29px;
	height: 29px;
}

.tooth-menu {
	font-size: 14px;
	font-family: Montserrat, sans-serif;
	display: none;
	position: absolute;
	width: auto;
	background-color: white;
	box-shadow: 0 0 5px grey;
	border-radius: 3px;
	z-index: 999;
	max-width: 140px;
}

.tooth-menu .tooth-menu-btn {
	width: 100%;
	background-color: #4687fc;
	color: white;
	margin: 0;
	padding: 5px;
	border: 0;
	border-top: 1px solid #D9E6FE;
}

.iopano-menu {
	max-width: 140px;
}

.tooth-menu>.tooth-menu-btn:first-child {
	border: 0;
}

.borderless-btn {
	width: 100%;
	background-color: #4687fc;
	color: white;
	margin: 0;
	padding: 5px;
	border: 0;
}

#selectColorControl {
	position: fixed;
	opacity: 0;
	width: 1px;
	height: 1px;
	left: calc(50% - 97px);
	top: calc(50% - 145px);
}

.teeth-list-btn {
	cursor: pointer;
	position: absolute;
	top: 5px;
	right: 12px;
	width: 30px;
	height: 30px;
	z-index: 1000;
}



#lbPatientName {
	position: absolute;
	top: 10px;
	right: 85px;
	width: auto;
	z-index: 1000;
	font-size: 14px;
	font-family: Montserrat, sans-serif;
	font-weight: bold;
}

.save-list-btn {
	position: absolute;
	top: 5px;
	right: 50px;
	width: 28px;
	height: 28px;
	z-index: 1000;
}

.save-list-img {
	cursor: pointer;
	position: absolute;
	width: 28px;
	height: 28px;
	top: 0;
	left: 0;
}

#saveListProgress {
	margin-top: -2px;
	width: 35px;
	height: 35px;
}

.switch-view-btn {
	position: absolute;
	width: 28px;
	height: 25px;
	cursor: pointer;
	top: 14px;
	z-index: 1000;
}

#analysisListBtn {
	width: 30px;
	height: 30px;
	top: 12px;
	left: 147px;
}

/* #segmented_view_btn {
	left: 14px;
	top: 14px;
} */

.cbct-zoom-container {
	position: absolute;
	text-align: center;
	left: 12px;
	top: 14px;
}

.cbct-zoom-btn {
	width: 20px;
	height: 20px;
	margin-right: 10px;
	/* margin-bottom: 12px; */
	color: white;
	cursor: pointer;
	/* font-size: 2rem; */
}

#dicom_view_btn {
	left: 72px;
}

#split_view_btn {
	left: 110px;
	height: 26px;
}

#loader {
	z-index: 1100;
	font-weight: bold;
	border-top-right-radius: 0.25rem;
	border-top-left-radius: 0.25rem;
	border-bottom-right-radius: 0.25rem;
	border-bottom-left-radius: 0.25rem;
}

#views_cont {
	width: 100%;
}

.flex-container {
	display: flex;
	flex-wrap: wrap;
	align-items: stretch;
	height: calc(100% - 35px);
	background: white;
	gap: 4px;
}

.flex-item {
	text-align: center;
	flex-grow: 1;
	box-sizing: border-box;
}

#views3d_wrapper {
	position: relative;
	display: block;
	margin: 0 auto;
	width: 100%;
	height: 100%;
	background: #EEF3FF;
	/* background: #77a7fd; 082F5E*/
}

#views3d_cont {
	position: relative;
	display: flex;
	flex-wrap: nowrap;
	align-items: stretch;
	margin: 0 auto;
	width: 100%;
	height: 100%;
	background: white;
	gap: 2px;
}

.view-flex-item {
	text-align: center;
	flex-grow: 1;
	box-sizing: border-box;
}

#stl_wrapper {
	position: relative;
	margin: 0 auto;
	width: calc(50% - 1px);
	height: 100%;
	background: #EEF3FF;
	/* background: #77a7fd; 082F5E*/
}

#dicom_3d_wrapper {
	position: relative;
	margin: 0 auto;
	width: calc(50% - 1px);
	height: 100%;
	font-size: 30px;
	background-color: black;
}

#dicomProcessingDiv {
	position: absolute;
	width: 300px;
	text-align: center;
	left: calc(50% - 150px);
	top: calc(50% - 30px);
	color: white;
}

#dicom3dLoadBtn {
	position: absolute;
	width: 200px;
	left: calc(50% - 100px);
	height: 35px;
	top: calc(50% + 30px);
	border: 0;
	cursor: pointer;
	font-size: small;
	background-color: #4687fc;
	text-align: center;
	color: #ffffff;
	font-size: 15px;
}

#stl_cont {
	margin: 0 auto;
	visibility: hidden;
	width: 100%;
	height: 100%;
}

/* .layer {
  position: absolute;
  pointer-events: none;
} */

#logoImg {
	position: absolute;
	left: 10px;
	bottom: 60px;
	z-index: 9;
	height: 30px;
}

#trademarkImg {
	position: absolute;
	left: 10px;
	bottom: 27px;
	z-index: 9;
	height: 25px;
}

#copyrightText {
	position: absolute;
	left: 10px;
	bottom: 7px;
	z-index: 9;
	color: #ffffff;
	font-size: x-small;
}

@media (max-width: 430px) {
	#trademarkImg {
		height: 20px;
		left: 5px;
		bottom: 20px;
	}

	#copyrightText {
		left: 5px;
		bottom: 2px;
	}
}

#infoImgBtm {
	position: absolute;
	left: 93px;
	bottom: 29px;
	z-index: 9;
	height: 30px;
	cursor: pointer;
}

.swal-wide {
	width: auto;
}

.swal-content {
	margin-top: 25px;
	margin-bottom: 15px;
}

.dropdown-menu {
	z-index: 99999;
}

#viewModeHint {
	position: absolute;
	width: 250px;
	left: calc(50% - 125px);
	top: 15px;
	background-color: transparent;
	color: red;
	font-weight: bold;
	text-align: center;
}

.centered-spinner {
	width: 100px;
	height: 100px;
	position: absolute;
	top: 50%;
	left: 50%;
	margin-left: -50px;
	margin-top: -50px;
	display: none;
	text-align: center;
	z-index: 9;
}

.slick-prev:before,
.slick-next:before {
	color: #0069d9;
}

.slider .slick-list .slick-slide {
	margin: 0 4px;
}

#tooltip {
	position: fixed;
	left: 0;
	top: 0;
	min-width: 100px;
	text-align: center;
	padding: 5px 12px;
	font-family: monospace;
	background: #a0c020;
	display: none;
	opacity: 0;
	border: 1px solid black;
	box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.5);
	transition: opacity 0.25s linear;
	border-radius: 3px;
}

.implant-disabled:disabled {
	color: #6c757d !important;
	text-decoration: none;
	background-color: transparent;
	pointer-events: none;
}

.annotation-menu {
	font-size: 14px;
	font-family: Montserrat, sans-serif;
	display: none;
	position: absolute;
	width: auto;
	background-color: white;
	box-shadow: 0 0 5px grey;
	border-radius: 3px;
	max-width: 180px;
	z-index: 999;
}

.annotation-menu>button {
	width: 100%;
	background-color: #4687fc;
	color: white;
	border: none;
	margin: 0;
	padding: 5px;
	border-top: 1px solid #D9E6FE;
}

.annotation-menu>button:first-child {
	border-top: 0;
}

.annotation-menu button:hover {
	background-color: rgb(182, 182, 182);
}
</style>
